import * as yup from 'yup';
import { VALIDATION_ERRORS } from '../../../../../../constraints';

export const useSchema = () => {
  return yup.object({
    tenantId: yup.string().required(VALIDATION_ERRORS.REQUIRED),
  });
};
